import React from "react";
import {
  Tooltip as ChakraTooltip,
  Portal,
} from "@chakra-ui/react";

export default function Tooltip({
  content,
  children,
  showArrow = true,
  portalled = true,
  portalRef,
  contentProps,
  disabled,
  ...rest
}) {

  if (disabled) return children;

  return (
    <ChakraTooltip.Root openDelay={200} closeDelay={100} {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>

      <Portal disabled={!portalled} container={portalRef}>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content
            bg="gray.800"
            color="white"
            px={3}
            py={1}
            borderRadius="md"
            fontSize="xs"
            boxShadow="md"
            {...contentProps}
          >
            {showArrow && (
              <ChakraTooltip.Arrow>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
}